import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    const isSurveyPage = location.pathname.startsWith('/surveys/');

    return (
        <header className="main-header">
            <div className='container d-flex justify-content-between align-items-center'>
                <Link to="/" id="logo" className='d-flex align-items-center text-decoration-none'>
                    <img alt="logo thebetteryou" src="/adaptive-icon-footer.png" className='img-fluid' style={{ width: "40px" }} />
                    <span className="brand-title">
                        TheBetter<span className="brand-you">You</span>
                    </span>
                </Link>
                <div className="d-flex align-items-center">
                    <div className="header-lang-switcher mr-2">
                        <LanguageSwitcher />
                    </div>
                    {!isSurveyPage && (
                        <>
                            <button className={`burger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Toggle navigation">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>

                            <nav className={`nav-links ${isMenuOpen ? 'show' : ''}`}>
                                <Link to="/about" className="nav-item" onClick={closeMenu}>{t('About')}</Link>
                                <Link to="/profiles" className="nav-item" onClick={closeMenu}>{t('Profiles')}</Link>
                                <Link to="/for-companies" className="nav-item" onClick={closeMenu}>{t('For Companies')}</Link>
                            </nav>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;